import get from 'lodash/get'
import PropTypes from 'prop-types'
import React, {Fragment, useEffect} from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import {fastlyImpolicyDCThumbnail} from '../../utils'

import * as ab from '../../store/ab'
import * as cross from '../../store/cross'
import * as productSelectors from '../../store/product'
import * as productActions from '../../actions/product'
import * as track from '../../track/track'

import AddToLookButton from './AddToLookButton'
import ProductSetItem from '../Pieces/ProductSetItem'
import ProductSetSliderWrapper from '../Pieces/ProductSetSliderWrapper'
import Throbber from '../Throbber'

const formatItems = (handleCTLModuleClick, items) =>
  items.map((item) => {
    const urlString = `/collections/${item.urlSlug}`
    return (
      <ProductSetItem
        key={item.id}
        handleClick={() => {
          track.pdpClicked(item.name, urlString, 'Clicked CompleteLookModule')
          handleCTLModuleClick()
        }}
        itemName={item.name}
        productImage={`${get(item, 'setImages[0].url')}${fastlyImpolicyDCThumbnail}`}
        url={urlString}
      />
    )
  })

const RecommendedItemsSlider = ({
  getRecommendedItems,
  handleCTLModuleClick,
  isLookbuilderPdpEntrypointActive,
  isPending,
  items,
  userIsParticipant,
}) => {
  useEffect(() => {
    getRecommendedItems()
  }, [getRecommendedItems])

  return (
    <section className="pdp-section recommended-items-slider">
      {isPending ? (
        <Throbber />
      ) : (
        <Fragment>
          <ProductSetSliderWrapper
            formattedItems={formatItems(handleCTLModuleClick, items)}
            title={isLookbuilderPdpEntrypointActive ? 'On the Model' : 'Complete the Look'}
          />
          {!userIsParticipant && items.length > 0 && (
            <div className="recommended-items-slider__button">
              <AddToLookButton isCTL buttonText="Rent These Accessories" />
            </div>
          )}
        </Fragment>
      )}
    </section>
  )
}

RecommendedItemsSlider.propTypes = {
  getRecommendedItems: PropTypes.func.isRequired,
  handleCTLModuleClick: PropTypes.func.isRequired,
  isLookbuilderPdpEntrypointActive: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      defaultDisplayCategorySlug: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      setImages: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
      ).isRequired,
      urlSlug: PropTypes.string.isRequired,
    }),
  ),
  userIsParticipant: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLookbuilderPdpEntrypointActive: ab.isLookbuilderPdpEntrypointActive,
  isPending: productSelectors.recommendedItemsIsPending,
  items: productSelectors.sortedRecommendedItems,
  userIsParticipant: cross.userIsParticipant,
})

const mapDispatchToProps = {
  getRecommendedItems: productActions.getRecommendedItems,
}

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedItemsSlider)
